export default "__VITE_ASSET__B2yn4DVo__"